import { Control, UseFormHandleSubmit } from "react-hook-form";
import { FormAnagrafica } from "./FormAnagrafica";
import { EmailContainer } from "./EmailContainer";
import { PasswordContainer } from "./PasswordContainer";
import { Divider } from "primereact/divider";
import { DeleteAccountContainer } from "./DeleteAccountContainer";
import { getUserRole } from "utils";

export const ProfileContainer = ({
  control,
  handleSubmit,
}: {
  control: Control<
    {
      name: string;
      lastName: string;
      email: string;
    },
    any
  >;
  handleSubmit: UseFormHandleSubmit<
    {
      name: string;
      lastName: string;
      email: string;
    },
    undefined
  >;
}) => {
  return (
    <div className="flex-container column gap-36 align-selft-center profile-container-item">
      <FormAnagrafica control={control} handleSubmit={handleSubmit} />
      <EmailContainer control={control} />
      <PasswordContainer />
      {getUserRole() !== "SUPERADMIN" && (
        <>
          <Divider className="margin-top-0 margin-bottom-0" />
          <DeleteAccountContainer />
        </>
      )}
    </div>
  );
};
